import React, { Component } from 'react'
import uuid from 'uuid'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { get } from 'lodash'

import { FilesList } from 'containers/misc'
import { Button } from 'components/misc'
import { AwardFileUpload, AwardFileEdit } from 'containers/forms/awards'
import { Section } from 'components/layout'
import { apiAwards } from 'helpers/decorators/api'
import { AwardFileDetail } from 'components/sections/awards'

const enhance = compose(
  apiAwards({
    files: true,
    updateFiles: true
  })
)

class AwardFiles extends Component {
  static propTypes = {
    decoAwardId: PropTypes.number,
    editAwardFile: PropTypes.func.isRequired,
    deleteAwardFile: PropTypes.func.isRequired,
    uploadAwardFiles: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    awards: PropTypes.object.isRequired
  }

  state = {
    fileDetail: null
  }

  key = uuid.v1()

  handleDisplayDetail = fileDetail => {
    this.setState(
      {
        fileDetail
      },
      () => {
        this.props.modal(`display-award-file-${this.key}`)
      }
    )
  }

  handleEditFile = fileDetail => {
    this.setState(
      {
        fileDetail
      },
      () => {
        this.props.modal(`edit-award-file-${this.key}`)
      }
    )
  }

  handleCloseModals = () => {
    this.props.modal(null)
    this.setState({
      fileDetail: null
    })
  }

  render() {
    const { awards, decoAwardId } = this.props

    const parentalConsentFiles = awards.files && awards.files.list && awards.files.list.filter(f => get(f, 'isParentalConsentFile'))

    const isContainParentalConsent = parentalConsentFiles.length > 0

    return (
      <Section>
        <div className="text--right">
          <Button
            intlKey="button.upload_file"
            onClick={() => this.props.modal(`upload-award-file-${this.key}`)}
          >
            Upload files
          </Button>
        </div>
        <FilesList
          awardId={decoAwardId}
          files={awards.files.list}
          onDisplayDetail={this.handleDisplayDetail}
          onEditFile={this.handleEditFile}
          hasTitle={false}
          loading={awards.loadingFiles}
        />
        <AwardFileDetail
          modalId={`display-award-file-${this.key}`}
          data={this.state.fileDetail}
        />
        <AwardFileEdit
          modalId={`edit-award-file-${this.key}`}
          data={this.state.fileDetail}
          editAwardFile={this.props.editAwardFile}
          deleteFile={this.props.deleteAwardFile}
          cancelUpload={this.handleCloseModals}
        />
        <AwardFileUpload
          modalId={`upload-award-file-${this.key}`}
          uploadAwardFiles={this.props.uploadAwardFiles}
          cancelUpload={this.handleCloseModals}
          isContainParentalConsent={isContainParentalConsent}
        />
      </Section>
    )
  }
}

export default enhance(AwardFiles)
